import * as S from './Divider.styles';

export const Divider = ({ margin }: { margin?: number }) => {
  return <S.DividerStyled margin={margin} />;
};
